import * as setting from 'api/settingAPI';

// Fonction pour récupérer le statut de la whitelist
export async function getWhitelistStatus() {
    try {
        const response = await setting.getWhitelistStatus();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération du statut de la whitelist :', error);
        throw new Error('Erreur lors de la récupération du statut de la whitelist.');
    }
};

// Fonction pour mettre à jour le statut de la whitelist
export async function upsertWhitelistStatus(status) {
    try {
        const response = await setting.upsertWhitelistStatus(status);
        return response;
    } catch (error) {
        console.error('Erreur lors de la mise à jour du statut de la whitelist :', error);
        throw new Error('Erreur lors de la mise à jour du statut de la whitelist.');
    }
};

// Fonction pour récupérer les utilisateurs whitelistés
export async function getUsersWhitelistAnnouncement() {
    try {
        const response = await setting.getUsersWhitelistAnnouncement();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération des utilisateurs whitelistés :', error);
        throw new Error('Erreur lors de la récupération des utilisateurs whitelistés.');
    }
};

// Fonction pour insérer un utilisateur dans la whitelist
export async function insertUserWhitelistAnnouncement(username) {
    try {
        const response = await setting.insertUserWhitelistAnnouncement(username);
        return response;
    } catch (error) {
        console.error('Erreur lors de l\'insertion d\'un utilisateur dans la whitelist :', error);
        throw new Error('Erreur lors de l\'insertion d\'un utilisateur dans la whitelist.');
    }
};

// Fonction pour supprimer un utilisateur de la whitelist
export async function deleteUserWhitelistAnnouncement(setting_id) {
    try {
        const response = await setting.deleteUserWhitelistAnnouncement(setting_id);
        return response;
    } catch (error) {
        console.error('Erreur lors de la suppression d\'un utilisateur de la whitelist :', error);
        throw new Error('Erreur lors de la suppression d\'un utilisateur de la whitelist.');
    }
};

// Fonction pour récupérer le statut du hub
export async function getHubStatus() {
    try {
        const response = await setting.getHubStatus();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération du statut du hub :', error);
        throw new Error('Erreur lors de la récupération du statut du hub.');
    }
};

// Fonction pour récupérer le thème du hub
export async function getThemeSite() {
    try {
        const response = await setting.getThemeSite();
        return response;
    } catch (error) {
        console.error('Erreur lors de la récupération du thème du hub :', error);
        throw new Error('Erreur lors de la récupération du thème du hub.');
    }
};

// Fonction pour modifier le theme du hub
export async function updateThemeSite(theme) {
    try {
        const response = await setting.updateThemeSite(theme);
        return response;
    } catch (error) {
        console.error('Erreur lors de la modification du theme du site :', error);
        throw new Error('Erreur lors de la modification du theme du site.');
    }
};

// Fonction pour récupérer les paramètres du bouton personnalisé (normalisée)
export async function getCustomButton() {
    try {
        const response = await setting.getCustomButton();
        const raw = response?.data;
        // Format 1: API déjà normalisée
        if (raw && typeof raw === 'object' && ('enabled' in raw || 'url' in raw || 'icon' in raw)) {
            return {
                enabled: !!raw.enabled,
                url: raw.url || '',
                icon: raw.icon || 'HelpCircle',
                tooltip: raw.tooltip || '',
            };
        }
        // Format 2: ligne SQL unique avec SIT_VALUE JSON
        if (raw && typeof raw === 'object' && 'SIT_VALUE' in raw) {
            try {
                const parsed = typeof raw.SIT_VALUE === 'string' ? JSON.parse(raw.SIT_VALUE) : (raw.SIT_VALUE || {});
                return {
                    enabled: !!parsed.enabled,
                    url: parsed.url || '',
                    icon: parsed.icon || 'HelpCircle',
                    tooltip: parsed.tooltip || '',
                };
            } catch {
                return { enabled: false, url: '', icon: 'HelpCircle', tooltip: '' };
            }
        }
        // Format 3: tableau
        if (Array.isArray(raw) && raw.length > 0) {
            const item = raw[0];
            if (item?.SIT_VALUE) {
                try {
                    const parsed = typeof item.SIT_VALUE === 'string' ? JSON.parse(item.SIT_VALUE) : (item.SIT_VALUE || {});
                    return {
                        enabled: !!parsed.enabled,
                        url: parsed.url || '',
                        icon: parsed.icon || 'HelpCircle',
                        tooltip: parsed.tooltip || '',
                    };
                } catch {
                    return { enabled: false, url: '', icon: 'HelpCircle', tooltip: '' };
                }
            }
            return {
                enabled: !!item?.ENABLED,
                url: item?.URL || '',
                icon: item?.ICON || 'HelpCircle',
                tooltip: item?.TOOLTIP || '',
            };
        }
        return { enabled: false, url: '', icon: 'HelpCircle', tooltip: '' };
    } catch (error) {
        console.error('Erreur lors de la récupération des paramètres du bouton personnalisé :', error);
        return { enabled: false, url: '', icon: 'HelpCircle', tooltip: '' };
    }
};

// Fonction pour modifier les paramètres du bouton personnalisé
export async function updateCustomButton(enabled, url, icon, tooltip) {
    try {
        const response = await setting.updateCustomButton(enabled, url, icon, tooltip);
        return response;
    } catch (error) {
        console.error('Erreur lors de la modification des paramètres du bouton personnalisé :', error);
        throw new Error('Erreur lors de la modification des paramètres du bouton personnalisé.');
    }
};